module.exports = __webpack_public_path__ + "static/media/gift-icon.41a3385e.svg";